import Utils from './utils';

export default {
  fade(element, time, onComplete, fadeIn = true) {
    if (!element) return;

    const defaultStartOpacity = fadeIn ? 0 : 1,
      finalOpacity = fadeIn ? 1 : 0,
      fadeTime = Utils.isNumeric(time) ? time : 150,
      numberOfIterations = 10,
      timeoutLength = fadeTime / numberOfIterations;

    let style = element.getAttribute('style');
    if (!style) style = `opacity:${defaultStartOpacity}`;
    else if (!style.includes('opacity'))
      style = style + (style.charAt(style.length - 1) === ';' ? '' : ';') + `opacity:${defaultStartOpacity};`;
    element.setAttribute('style', style);

    const currentOpacity = this.getOpacityFromStyle(style);
    if (!Utils.isNumeric(currentOpacity)) return;
    const opacityChange = finalOpacity - currentOpacity;
    const opacityIterationChange = opacityChange / numberOfIterations;

    this.recursiveFade(element, 0, numberOfIterations, opacityIterationChange, timeoutLength, finalOpacity, onComplete);
  },

  getOpacityFromStyle(style) {
    const result = style.match(/opacity:(.*\d)/);
    if (result && result.length >= 2 && Utils.isNumeric(result[1])) return Number(result[1]);
    else return null;
  },

  recursiveFade(element, count, numberOfIterations, opacityChange, timeoutLength, finalOpacity, onComplete) {
    setTimeout(() => {
      let style = element.getAttribute('style');
      if (count === numberOfIterations - 1) {
        element.setAttribute('style', style.replace(/opacity:(.*\d)/, `opacity:${finalOpacity}`));
        if (onComplete) onComplete();
        return;
      } else {
        const currentOpacity = this.getOpacityFromStyle(style);
        element.setAttribute('style', style.replace(/opacity:(.*\d)/, `opacity:${currentOpacity + opacityChange}`));
        this.recursiveFade(
          element,
          count + 1,
          numberOfIterations,
          opacityChange,
          timeoutLength,
          finalOpacity,
          onComplete,
        );
      }
    }, timeoutLength);
  },
};
